export default {
  API_URL: "https://api-cms.madmax.kkvqa.com/v1",
  PLAYER_URL: "https://player.madmax.kkvqa.com",
  EVENT_SITE_URL: "https://event.madmax.kkvqa.com",
  CHATROOM_URL: "https://chatroom.madmax.kkvqa.com",
};
